import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrdersService} from '../../dashboard/orders/orders.service';

@Component({
  selector: 'app-add-documents-modal',
  templateUrl: './add-documents-modal.component.html',
  styleUrls: ['./add-documents-modal.component.scss']
})
export class AddDocumentsModalComponent implements OnInit {
  order: any;
  fileTypes: { name: string; label: string; description: string; id: number }[];
  uploadedFiles: boolean;
  onUpload: EventEmitter<any> = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddDocumentsModalComponent>, private ordersService: OrdersService) {
  }

  ngOnInit(): void {
    this.order = this.data.order;
    this.fileTypes = this.data.fileTypes;
  }

  saveOrder() {
    this.onUpload.emit(true);
  }
}
